export const MAIN = 'main'
export const SLIDER = 'slider'
export const STRIPE = 'stripe'
export const HIGHLIGHT = 'highlight'
export const ADVERTISEMENT = 'advertisement'
export const OVERVIEW = 'overview'
export const OVERVIEWLINK = 'overviewLink'
export const BANNER = 'banner'

export const FILTER = 'filter'
export const EXPIREDATE = 'expireDate'
export const CONTENT = 'content'

//FILTER OPTIONS
export const PERIOD = 'period'
export const GENRES = 'genres'
export const ATTRIBUTES = 'technical'